export default "__VITE_ASSET__UVLdoE6K__"